import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        // 接口基址可通过 .env / .env.development 的 VUE_APP_API_BASE 覆盖
        WebURL: process.env.VUE_APP_API_BASE || 'https://www.pruton.com/api',
        msg1: ''
    },
    mutations: {
        // 富文本编辑器正文：由编辑器子组件写入，新增/编辑页读取
        setEditorContent(state, content: string) {
            state.msg1 = content
        }
    },
    actions: {}
})
